<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Role Details</ion-title>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <div class="role-details-wrapper page_padding_top">
      <div class="flex-view">
        <div class="main_text">Vacancy</div>
        <div class="main-text">
          {{ deets.vacancy.from }} - {{ deets.vacancy.to }}
        </div>
      </div>

      <div class="flex-view role-details-padding-top">
        <div class="main_text">Hourly Rate</div>
        <div class="main-text">
          ${{ Number(deets.rate.from).toFixed(2) }} - ${{
            Number(deets.rate.to).toFixed(2)
          }}
        </div>
      </div>

      <div class="flex-view role-details-padding-top">
        <div class="main_text">Language</div>
        <div class="main-text flex-view">
          {{ deets.languages.join(", ") }}
        </div>
      </div>

      <div class="flex-view role-details-padding-top">
        <div class="main_text dark-text">COVID {{ message.Immuniser }} Req?</div>
        <div class="main_text">{{ deets.immuniserReq ? "Yes" : "No" }}</div>
      </div>

      <div class="flex-view role-details-padding-top">
        <div class="main_text">Number of Technicians</div>
        <div class="main_text">{{ deets.technicians }}</div>
      </div>

      <div class="role-details-shift-wrapper role-details-padding-top">
        <div v-for="(shift, index) in deets.shifts" :key="index" class="shift">
          <div class="vertical-align">
            <div class="flex-view">
              <div class="margin-right circle"></div>
              <div>
                <div class="shift-title">{{ shift.title }}</div>
                <div class="shift-time">
                  {{ shift.time.from }} - {{ shift.time.to }}
                </div>
              </div>
            </div>

            <div class="shift-amt">{{ shift.shifts }} Shift</div>
          </div>
        </div>
      </div>

      <div class="additional_text margin-top">
        Has this shift been fulfilled by an Agency?
      </div>

      <el-button
        :type="'blue'"
        v-if="deets.agencyOptionEnabled"
        class="action-button"
        @click="showPopup()"
        >Mark as Agency Fulfilled</el-button
      >
    </div>

    <el-dialog
      v-model="centerDialogVisible"
      title="Agency Fulfilled"
      width="30%"
      center
      :show-close="false"
      custom-class="dialog-class"
    >
      <div class="popup-text">
        Are you sure this shift has been fulfilled by an Agency? It will no
        longer be visible
      </div>

      <div class="button-combo">
        <el-button :type="'grey'" class="action-button" @click="closePopup()"
          >Cancel</el-button
        >

        <el-button
          :type="'green'"
          class="action-button green-button"
          @click="showPopup()"
          >Yes</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, inject, ref } from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";

import { useStore } from "vuex";

import {
  useRouter,
  // useRoute
} from "vue-router";

import "./index.scss";

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
  },
  directives: {},

  setup() {
    const $store = useStore();
    const $router = useRouter();
    const centerDialogVisible = ref(false);

    const setPageClassGlobal = inject("setPageClassGlobal");
    const mainMenuShow = inject("mainMenuShow");
    const message = inject("messages");

    const user = $store.getters.GET_USER_DATA;
    const deets = {
      vacancy: {
        from: "14 Jul",
        to: "14 Jul",
      },
      rate: {
        from: 49,
        to: 65,
      },
      languages: ["English", "France"],
      immuniserReq: true,
      technicians: 2,
      shifts: [
        {
          title: "Mondays",
          time: {
            from: "9:00AM",
            to: "5:00PM",
          },
          shifts: 1,
        },
        {
          title: "Mondays",
          time: {
            from: "9:00AM",
            to: "5:00PM",
          },
          shifts: 1,
        },
        {
          title: "Mondays",
          time: {
            from: "9:00AM",
            to: "5:00PM",
          },
          shifts: 1,
        },
        {
          title: "Mondays",
          time: {
            from: "9:00AM",
            to: "5:00PM",
          },
          shifts: 1,
        },
        {
          title: "Mondays",
          time: {
            from: "9:00AM",
            to: "5:00PM",
          },
          shifts: 1,
        },
        {
          title: "Mondays",
          time: {
            from: "9:00AM",
            to: "5:00PM",
          },
          shifts: 1,
        },

        {
          title: "Mondays",
          time: {
            from: "9:00AM",
            to: "5:00PM",
          },
          shifts: 1,
        },

        {
          title: "Mondays",
          time: {
            from: "9:00AM",
            to: "5:00PM",
          },
          shifts: 1,
        },

        {
          title: "Mondays",
          time: {
            from: "9:00AM",
            to: "5:00PM",
          },
          shifts: 1,
        },
        {
          title: "Mondays",
          time: {
            from: "9:00AM",
            to: "5:00PM",
          },
          shifts: 1,
        },
        {
          title: "Mondays",
          time: {
            from: "9:00AM",
            to: "5:00PM",
          },
          shifts: 1,
        },
      ],
      agencyOptionEnabled: true,
    };

    const goBack = () => {
      $router.push({
        name: "profile",
      });
    };

    const showPopup = () => {
      centerDialogVisible.value = true;
    };

    const closePopup = () => {
      centerDialogVisible.value = false;
    };

    onMounted(() => {
      setPageClassGlobal("global_profile_page");
      mainMenuShow(true);
    });

    return {
      user,
      deets,
      goBack,
      centerDialogVisible,
      showPopup,
      closePopup,
      message
    };
  },
};
</script>
